import { FindUserModalComponent } from '@common/auth/find-user-modal/find-user-modal.component';
import {
    DatatableFilter,
    FilterControlType
} from '@common/datatable/datatable-filters/search-input-with-filters/filter-config/datatable-filter';
import {
    CreatedAtFilter,
    UpdatedAtFilter
} from '@common/datatable/datatable-filters/search-input-with-filters/filter-config/timestamp-filter';

export const LINK_OVERLAY_FILTERS: DatatableFilter[] = [
    new DatatableFilter({
        type: FilterControlType.Select,
        key: 'theme',
        defaultValue: 'default',
        description: 'Active theme for link overlay',
        options: [
            {key: 'default', value: 'default'},
            {key: 'full-width', value: 'full-width'},
            {key: 'rounded', value: 'rounded'},
            {key: 'pill', value: 'pill'},
        ],
    }),
    new CreatedAtFilter({
        description: 'Date overlay was created',
    }),
    new UpdatedAtFilter({
        description: 'Date overlay was last updated',
    }),
    new DatatableFilter({
        type: FilterControlType.SelectModel,
        key: 'user_id',
        label: 'User',
        description: 'User overlay was created by',
        component: FindUserModalComponent,
    }),
];
